import { all, call, takeLatest, put } from 'redux-saga/effects';
import {
  SET_SEARCH_PENDING,
  GET_SEARCH_RESULTS,
  GET_CONFIRM_SEARCH_RESULTS,
  GET_TO_SHIP_SEARCH_RESULTS,
  GET_SHIPPED_SEARCH_RESULTS,
  GET_OPEN_SEARCH_RESULTS,
  GET_DELIVERED_SEARCH_RESULTS,
  GET_RETURNED_SEARCH_RESULTS,
  GET_CANCELED_SEARCH_RESULTS,
  GET_COMPLETED_SEARCH_RESULTS,
  SET_ACTIVE_LISTINGS,
  SET_NEED_TO_CONFIRM_ORDERS,
  SET_NEED_TO_SHIP_ORDERS,
  SET_OPEN_ORDERS,
  SET_SHIPPED_ORDERS,
  SET_DELIVERED_ORDERS,
  SET_RETURNED_ORDERS,
  SET_CANCELED_ORDERS,
  SET_COMPLETED_ORDERS,
} from 'store/constants/action-types';
import {
  fetchActiveLisitngsSearchResults,
  fetchConfirmSearchResults,
  fetchToShipSearchResults,
  fetchShippedSearchResults,
  fetchOpenSearchResults,
  fetchDeliveredSearchResults,
  fetchReturnedSearchResults,
  fetchCanceledSearchResults,
  fetchCompletedSearchResults,
} from 'services/api/search-api';

export function* getSearchResults(action) {
  try {
    const response = yield call(fetchActiveLisitngsSearchResults, action.searchParam, action.page);
    yield put({ type: SET_ACTIVE_LISTINGS, payload: response });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    // console.log(error);
  }
}

export function* getConfirmSearchResult(action) {
  try {
    const response = yield call(fetchConfirmSearchResults, action.searchParam, action.page);
    yield put({ type: SET_NEED_TO_CONFIRM_ORDERS, payload: response });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    // console.log(error);
  }
}

export function* getToShipSearchResult(action) {
  try {
    const response = yield call(fetchToShipSearchResults, action.searchParam, action.page);
    yield put({ type: SET_NEED_TO_SHIP_ORDERS, payload: response });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    // console.log(error);
  }
}

export function* getShippedSearchResult(action) {
  try {
    const response = yield call(fetchShippedSearchResults, action.searchParam, action.page);
    yield put({ type: SET_SHIPPED_ORDERS, payload: response });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    // console.log(error);
  }
}

export function* getOpenSearchResult(action) {
  try {
    const response = yield call(fetchOpenSearchResults, action.searchParam, action.page);
    yield put({ type: SET_OPEN_ORDERS, payload: response });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    // console.log(error);
  }
}

export function* getDeliveredSearchResult(action) {
  try {
    const response = yield call(fetchDeliveredSearchResults, action.searchParam, action.page);
    yield put({ type: SET_DELIVERED_ORDERS, payload: response });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    // console.log(error);
  }
}

export function* getReturnedSearchResult(action) {
  try {
    const response = yield call(fetchReturnedSearchResults, action.searchParam, action.page);
    yield put({ type: SET_RETURNED_ORDERS, payload: response });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    // console.log(error);
  }
}

export function* getCanceledSearchResult(action) {
  try {
    const response = yield call(fetchCanceledSearchResults, action.searchParam, action.page);
    yield put({ type: SET_CANCELED_ORDERS, payload: response });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    // console.log(error);
  }
}

export function* getCompletedSearchResult(action) {
  try {
    const response = yield call(fetchCompletedSearchResults, action.searchParam, action.page);
    yield put({ type: SET_COMPLETED_ORDERS, payload: response });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    // console.log(error);
  }
}

export function* watchgetActiveListingsSearchResults() {
  yield takeLatest(GET_SEARCH_RESULTS, getSearchResults);
}

export function* watchgetConfirmSearchResults() {
  yield takeLatest(GET_CONFIRM_SEARCH_RESULTS, getConfirmSearchResult);
}

export function* watchgetToShipSearchResults() {
  yield takeLatest(GET_TO_SHIP_SEARCH_RESULTS, getToShipSearchResult);
}

export function* watchgetShippedSearchResults() {
  yield takeLatest(GET_SHIPPED_SEARCH_RESULTS, getShippedSearchResult);
}

export function* watchgetOpenSearchResults() {
  yield takeLatest(GET_OPEN_SEARCH_RESULTS, getOpenSearchResult);
}

export function* watchgetDeliveredSearchResults() {
  yield takeLatest(GET_DELIVERED_SEARCH_RESULTS, getDeliveredSearchResult);
}

export function* watchgetReturnedSearchResults() {
  yield takeLatest(GET_RETURNED_SEARCH_RESULTS, getReturnedSearchResult);
}

export function* watchgetCanceledSearchResults() {
  yield takeLatest(GET_CANCELED_SEARCH_RESULTS, getCanceledSearchResult);
}

export function* watchgetCompletedSearchResults() {
  yield takeLatest(GET_COMPLETED_SEARCH_RESULTS, getCompletedSearchResult);
}

export default function* searchSagas() {
  yield all([
    watchgetActiveListingsSearchResults(),
    watchgetConfirmSearchResults(),
    watchgetToShipSearchResults(),
    watchgetShippedSearchResults(),
    watchgetOpenSearchResults(),
    watchgetDeliveredSearchResults(),
    watchgetReturnedSearchResults(),
    watchgetCanceledSearchResults(),
    watchgetCompletedSearchResults(),
  ]);
}
